export default "__VITE_ASSET__x9P562c5__"